<template>
  <div class="notree-boxbgcolor">
    <div class="searchbox">
      <form
        action="#"
        method="get"
        class="form-inline form-float"
        @submit.native.prevent
      >
        <div class="form-group">
          <label for="companyName">企业名称</label>
          <input
            v-model.trim="search.companyName"
            class="form-control"
            type="text"
            placeholder="请输入企业名称"
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for="taxNumber">企业税号</label>
          <input
            v-model.trim="search.taxNumber"
            class="form-control"
            type="text"
            placeholder="请输入企业税号"
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              查询
            </button>
          </span>
          <span class="add_btn">
            <button
              @click="addOrEdit()"
              type="button"
              class="btn btn-default"
              id="addarea"
            >
              新增
            </button>
          </span>
        </div>
      </form>
    </div>

    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column
          show-overflow-tooltip
          label="企业名称"
          prop="companyName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="企业税号"
          prop="taxNumber"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="税率(%)" prop="taxRate">
          <template slot-scope="scope"> {{ scope.row.taxRate }}% </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="关联车场"
          prop="parkingNames"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.parkingNames && scope.row.parkingNames.length > 0"
            >
              {{ scope.row.parkingNames.join(", ") }}
            </span>
            <span v-else class="text-muted">未关联</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="创建时间"
          prop="crtTime"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="280px">
          <template slot-scope="scope">
            <button
              class="edit operate-button"
              type="button"
              @click="addOrEdit(scope.row.id)"
            >
              修改
            </button>
            <button
              class="delete operate-button"
              type="button"
              @click="del(scope.row.id)"
            >
              删除
            </button>
            <button
              class="operate-button"
              type="button"
              @click="linkParking(scope.row.id)"
            >
              关联车场
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <Page v-on:pagination="receivePaginationData"></Page>

    <!-- 新增/修改发票配置 -->
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="500px"
      @open="openDialog"
      @close="closeDialog"
    >
      <el-form
        ref="form"
        label-position="right"
        :model="form"
        :rules="rules"
        :label-width="formLabelWidth"
      >
        <el-form-item label="企业名称" prop="companyName">
          <input
            v-model.trim="form.companyName"
            class="form-control"
            type="text"
            placeholder="请输入企业名称"
            size="12"
          />
        </el-form-item>
        <el-form-item label="企业税号" prop="taxNumber">
          <input
            v-model.trim="form.taxNumber"
            class="form-control"
            type="text"
            placeholder="请输入企业税号"
            size="12"
          />
        </el-form-item>
        <el-form-item label="税率(%)" prop="taxRate">
          <input
            v-model.number="form.taxRate"
            class="form-control"
            type="number"
            placeholder="请输入税率"
            size="12"
            min="0"
            max="100"
            step="0.01"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <textarea
            v-model.trim="form.remark"
            class="form-control"
            placeholder="请输入备注信息"
            rows="3"
          ></textarea>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          type="button"
          class="btn btn-default"
          @click="dialogFormVisible = false"
        >
          取消
        </button>
        <button type="button" class="btn btn-primary" @click="submitForm">
          确定
        </button>
      </div>
    </el-dialog>

    <!-- 关联车场右侧滑出popup -->
    <div
      class="parking-popup-overlay"
      v-if="parkingDialogVisible"
      @click="closeParkingDialog"
    ></div>
    <div
      class="parking-popup"
      :class="{ 'parking-popup-active': parkingDialogVisible }"
      style="width: 700px"
    >
      <div class="parking-popup-header">
        <h3>关联车场</h3>
        <button type="button" class="close-btn" @click="closeParkingDialog">
          <span>&times;</span>
        </button>
      </div>
      <div class="parking-popup-content">
        <div class="parking-link-container">
          <div class="parking-section">
            <div class="parking-list">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 10px;
                "
              >
                <h4>可选车场列表</h4>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="addToLinked"
                >
                  添加关联
                </button>
              </div>

              <el-table
                ref="availableParkingTable"
                :data="availableParkingList"
                max-height="300"
                border
                @selection-change="handleParkingSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  label="车场名称"
                  prop="parkName"
                  width="120"
                  min-width="100"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="车场编号"
                  prop="parkCode"
                  width="100"
                  min-width="80"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column 
                  label="地址" 
                  prop="address"
                 
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
            </div>
          </div>

          <div class="parking-section">
            <div class="linked-parking-list">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 10px;
                "
              >
                <h4>已关联车场列表</h4>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="removeFromLinked"
                >
                  移除关联
                </button>
              </div>
                <el-table
                
               ref="linkedParkingTable"
                :data="availableParkingList"
                max-height="300"
                border
                @selection-change="handleLinkedParkingSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  label="车场名称"
                  prop="parkName"
                  width="120"
                  min-width="100"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="车场编号"
                  prop="parkCode"
                  width="100"
                  min-width="80"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column 
                  label="地址" 
                  prop="address"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
           
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Page from "../../commons/page.vue";

export default {
  name: "InvoiceConfig",
  components: {
    Page,
  },
  data() {
    return {
      // 表格样式
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      // 表格数据
      tableListData: [],

      // 搜索条件
      search: {
        pageNumber: 1,
        pageSize: 10,
        companyName: "",
        taxNumber: "",
      },

      // 表单数据
      form: {
        id: "",
        companyName: "",
        taxNumber: "",
        taxRate: "",
        remark: "",
      },

      // 表单验证规则
      rules: {
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        taxNumber: [
          { required: true, message: "请输入企业税号", trigger: "blur" },
          {
            pattern: /^[0-9]{15,20}$/,
            message: "企业税号格式不正确",
            trigger: "blur",
          },
        ],
        taxRate: [
          { required: true, message: "请输入税率", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 100,
            message: "税率必须在0-100之间",
            trigger: "blur",
          },
        ],
      },

      // 对话框相关
      dialogFormVisible: false,
      dialogTitle: "新增发票配置",
      formLabelWidth: "100px",

      // 关联车场相关
      parkingDialogVisible: false,
      currentInvoiceId: "",
      availableParkingList: [],
      linkedParkingList: [],
      selectedAvailableParkingIds: [],
      selectedLinkedParkingIds: [],

      // 分页相关
      pagination: {
        total: 0,
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.getList();
    this.getParkingList();
  },
  methods: {
    // 获取发票配置列表
    getList() {
      // 模拟数据，实际项目中应该调用API
      this.tableListData = [
        {
          id: 1,
          companyName: "示例企业有限公司",
          taxNumber: "91110000123456789X",
          taxRate: 13.0,
          parkingNames: ["示例车场A", "示例车场B"],
          crtTime: "2024-01-15 10:30:00",
        },
        {
          id: 2,
          companyName: "测试企业集团",
          taxNumber: "91110000987654321Y",
          taxRate: 9.0,
          parkingNames: ["测试车场C"],
          crtTime: "2024-01-14 15:20:00",
        },
      ];
    },

    // 获取车场列表
    getParkingList() {
      // 模拟数据，实际项目中应该调用API
      this.availableParkingList = [
        {
          id: 1,
          parkName: "示例车场A",
          parkCode: "P001",
          address: "北京市朝阳区示例路123号",
        },
        {
          id: 2,
          parkName: "示例车场B",
          parkCode: "P002",
          address: "北京市海淀区示例路456号",
        },
        {
          id: 3,
          parkName: "测试车场C",
          parkCode: "P003",
          address: "北京市西城区示例路789号",
        },
      ];
    },

    // 搜索列表
    searchList() {
      this.search.pageNumber = 1;
      this.getList();
    },

    // 新增或编辑
    addOrEdit(id) {
      if (id) {
        // 编辑模式
        this.dialogTitle = "修改发票配置";
        const row = this.tableListData.find((item) => item.id === id);
        if (row) {
          this.form = { ...row };
        }
      } else {
        // 新增模式
        this.dialogTitle = "新增发票配置";
        this.resetForm();
      }
      this.dialogFormVisible = true;
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: "",
        companyName: "",
        taxNumber: "",
        taxRate: "",
        remark: "",
      };
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    // 打开对话框
    openDialog() {
      // 对话框打开时的处理逻辑
    },

    // 关闭对话框
    closeDialog() {
      this.resetForm();
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            // 修改
            this.updateInvoiceConfig();
          } else {
            // 新增
            this.addInvoiceConfig();
          }
        }
      });
    },

    // 新增发票配置
    addInvoiceConfig() {
      // 模拟新增，实际项目中应该调用API
      const newConfig = {
        id: Date.now(),
        ...this.form,
        parkingNames: [],
        crtTime: new Date().toLocaleString(),
      };
      this.tableListData.unshift(newConfig);
      this.dialogFormVisible = false;
      this.$message.success("新增成功");
    },

    // 修改发票配置
    updateInvoiceConfig() {
      // 模拟修改，实际项目中应该调用API
      const index = this.tableListData.findIndex(
        (item) => item.id === this.form.id
      );
      if (index !== -1) {
        this.tableListData[index] = {
          ...this.tableListData[index],
          ...this.form,
        };
      }
      this.dialogFormVisible = false;
      this.$message.success("修改成功");
    },

    // 删除发票配置
    del(id) {
      this.$confirm("确定要删除这条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 模拟删除，实际项目中应该调用API
          const index = this.tableListData.findIndex((item) => item.id === id);
          if (index !== -1) {
            this.tableListData.splice(index, 1);
          }
          this.$message.success("删除成功");
        })
        .catch(() => {
          // 取消删除
        });
    },

    // 关联车场
    linkParking(id) {
      this.currentInvoiceId = id;
      const row = this.tableListData.find((item) => item.id === id);
      if (row && row.parkingNames && row.parkingNames.length > 0) {
        // 根据已关联的车场名称找到对应的完整车场对象
        this.linkedParkingList = this.availableParkingList.filter((parking) =>
          row.parkingNames.includes(parking.parkName)
        );
        console.log("this.linkedParkingList",this.linkedParkingList)
        // 确保所有已关联的车场都有完整信息
        // this.linkedParkingList = this.linkedParkingList.map((parking) => ({
        //   id: parking.id,
        //   parkName: parking.parkName,
        //   parkCode: parking.parkCode,
        //   address: parking.address,
        // }));
      } else {
        this.linkedParkingList = [];
      }
      this.parkingDialogVisible = true;
    },

    // 处理车场选择变化
    handleParkingSelectionChange(selection) {
      this.selectedAvailableParkingIds = selection.map((item) => item.id);
    },

    // 处理已关联车场选择变化
    handleLinkedParkingSelectionChange(selection) {
      this.selectedLinkedParkingIds = selection.map((item) => item.id);
    },

    // 添加到已关联列表
    addToLinked() {
      if (this.selectedAvailableParkingIds.length === 0) {
        this.$message.warning("请先选择要关联的车场");
        return;
      }

      const selectedParkings = this.availableParkingList.filter((parking) =>
        this.selectedAvailableParkingIds.includes(parking.id)
      );

      // 避免重复添加
      selectedParkings.forEach((parking) => {
        if (!this.linkedParkingList.find((item) => item.id === parking.id)) {
          this.linkedParkingList.push(parking);
        }
      });

      // 立即更新表格数据中的关联车场
      this.updateLinkedParkingInTable();
      this.$message.success("添加关联成功");

      // 重置选择状态
      this.selectedAvailableParkingIds = [];
      this.$refs.availableParkingTable &&
        this.$refs.availableParkingTable.clearSelection();
    },

    // 从已关联列表移除
    removeFromLinked() {
      if (this.selectedLinkedParkingIds.length === 0) {
        this.$message.warning("请先选择要移除的车场");
        return;
      }

      this.linkedParkingList = this.linkedParkingList.filter(
        (parking) => !this.selectedLinkedParkingIds.includes(parking.id)
      );

      // 立即更新表格数据中的关联车场
      this.updateLinkedParkingInTable();
      this.$message.success("移除关联成功");

      // 重置选择状态
      this.selectedLinkedParkingIds = [];
      this.$refs.linkedParkingTable &&
        this.$refs.linkedParkingTable.clearSelection();
    },

    // 更新表格数据中的关联车场
    updateLinkedParkingInTable() {
      const index = this.tableListData.findIndex(
        (item) => item.id === this.currentInvoiceId
      );
      if (index !== -1) {
        this.tableListData[index].parkingNames = this.linkedParkingList.map(
          (parking) => parking.parkName
        );
      }
    },

    // 关闭关联车场对话框
    closeParkingDialog() {
      this.parkingDialogVisible = false;
      this.currentInvoiceId = "";
      this.linkedParkingList = [];
      this.selectedAvailableParkingIds = [];
      this.selectedLinkedParkingIds = [];
    },

    // 接收分页数据
    receivePaginationData(pageNumber, pageSize) {
      this.search.pageNumber = pageNumber;
      this.search.pageSize = pageSize;
      this.getList();
    },
  },
};
</script>

<style scoped>
.parking-link-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.parking-section {
  display: flex;
  gap: 15px;
  align-items: flex-start;
  width:100%;
}

.parking-list,
.linked-parking-list {
  flex: 1;
}

.parking-list h4,
.linked-parking-list h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 14px;
}

.parking-action-right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 40px;
}

.parking-action-right .btn {
  min-width: 80px;
  white-space: nowrap;
}

.text-muted {
  color: #999;
}

.dialog-footer {
  text-align: right;
}

.dialog-footer .btn {
  margin-left: 10px;
}

/* 右侧滑出popup样式 */
.parking-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.parking-popup {
  position: fixed;
  top: 0;
  right: -700px;
  width: 700px;
  height: 100vh;
  background-color: #fff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
}

.parking-popup-active {
  right: 0;
}

.parking-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e4e7ed;
  background-color: #f9f9fb;
}

.parking-popup-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 500;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-btn:hover {
  background-color: #f0f0f0;
  color: #666;
}

.parking-popup-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

/* 移除parking-popup-footer样式，因为不再需要底部按钮区域 */

/* 优化弹窗中表格的显示效果 */
.parking-list .el-table,
.linked-parking-list .el-table {
  width: 100%;
  overflow-x: hidden;
}

.parking-list .el-table .el-table__body-wrapper,
.linked-parking-list .el-table .el-table__body-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
}

.parking-list .el-table .el-table__header-wrapper,
.linked-parking-list .el-table .el-table__header-wrapper {
  overflow-x: hidden;
}

/* 确保表格内容不会超出容器 */
.parking-list,
.linked-parking-list {
  overflow: visible;
}

/* 优化弹窗内容区域的布局 */
.parking-popup-content {
  padding: 20px;
  overflow: visible;
}

.parking-link-container {
  overflow: visible;
}

/* 优化表格滚动条样式 */
.parking-list .el-table .el-table__body-wrapper::-webkit-scrollbar,
.linked-parking-list .el-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px;
}

.parking-list .el-table .el-table__body-wrapper::-webkit-scrollbar-track,
.linked-parking-list .el-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.parking-list .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb,
.linked-parking-list .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.parking-list .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb:hover,
.linked-parking-list .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
